/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["મ.રાત્રિ","સવારે","બપોરે","સાંજે","રાત્રે"],["મધ્યરાત્રિ","સવારે","બપોરે","સાંજે","રાત્રે"],u],[["મધ્યરાત્રિ","સવારે","બપોરે","સાંજે","રાત્રે"],u,["મધ્યરાત્રિ","સવાર","બપોર","સાંજ","રાત્રિ"]],["00:00",["04:00","12:00"],["12:00","16:00"],["16:00","20:00"],["20:00","04:00"]]];
